import { Routes } from '@angular/router';


export const termsConditionsRoutes: Routes = [
  {
    path: 'smsterms',
    loadComponent: () => import('./components/terms-conditions/terms-conditions.component').then(c => c.TermsConditionsComponent)
  }
];

